export default __webpack_public_path__ + "static/media/forces_and_mass_lab_thumbnail.7b9796d5.png";